module.exports = __webpack_public_path__ + "static/media/sopt28ru.f9162ee0.pdf";